// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3KjAn","topBottomGutter":"Layout_topBottomGutter__209Rx"};